import { Link } from "@tanstack/react-router";
import { useTranslation } from "../../i18n";
import { Button } from "../ui/button";

export function HomeInfoPlaceholder({ page }: { page: "about" | "contact" }) {
  const { t } = useTranslation();
  return <section className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-start justify-center gap-6 px-6 py-24">
    <p className="m-0 text-sm text-muted-foreground">{t("creativeHome.info.preparing")}</p>
    <h1 className="m-0 text-4xl font-medium tracking-tight">{t(`creativeHome.info.${page}.title`)}</h1>
    <p className="m-0 max-w-xl text-base leading-8 text-muted-foreground">{t(`creativeHome.info.${page}.description`)}</p>
    <Button asChild variant="outline"><Link to="/">{t("creativeHome.info.back")}</Link></Button>
  </section>;
}
